import { Link } from "react-router-dom";
import Badge from "../../shared/Badge";
import { TagBadgeList } from "../../components/Tags";
import { formatDate, renderAmount } from "../../utils";
import {
  renderCustomColumnDefs,
  renderValidations,
} from "../../shared/Table/table.utils";
import { getInvoiceStatusColor, getInvoiceStatusLabel } from "./utils";

const tableConfig = [
  {
    id: "invoiceNumber",
    visible: true,
    cell: ({ row: { original }, getValue }) => (
      <Link
        className="text-primary-600 hover:underline"
        to={`/invoices/v2/${original._id}`}
      >
        {getValue()}
      </Link>
    ),
  },
  {
    id: "status",
    visible: true,
    cell: ({ getValue }) => (
      <Badge color={getInvoiceStatusColor(getValue())} label={getInvoiceStatusLabel(getValue())} />
    ),
  },
  {
    id: "dueDate",
    visible: true,
    cell: ({ getValue }) => formatDate(getValue(), null, true),
  },
  {
    id: "client",
    visible: true,
    cell: ({ getValue }) => getValue()?.name || "N/A",
  },
  {
    id: "tags",
    header: "Tags",
    visible: true,
    cell: ({ row: { original } }) => (
      <TagBadgeList tags={original?.tags || []} emptyText="—" size="sm" />
    ),
  },
  {
    id: "lineItems",
    header: "Lines",
    visible: true,
    cell: ({ getValue }) => (Array.isArray(getValue()) ? getValue().length : 0),
  },
  {
    id: "totals",
    header: "Total",
    visible: true,
    cell: ({ getValue }) => renderAmount(getValue?.grandTotal || 0),
  },
  {
    id: "balanceDue",
    header: "Balance due",
    visible: true,
    cell: ({ row: { original } }) => renderAmount(original?.totals?.balanceDue || 0),
  },
  {
    id: "updatedAt",
    header: "Updated",
    visible: true,
    cell: ({ getValue }) => formatDate(getValue(), null, true),
  },
  {
    id: "_id",
    header: "id",
    visible: false,
    width: 230,
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
export const FORM_OPTIONS = { validations: renderValidations(tableConfig) };
export const PAGE_SIZE_OPTIONS = [
  { label: "10 Invoices", value: 10 },
  { label: "20 Invoices", value: 20 },
  { label: "50 Invoices", value: 50 },
  { label: "100 Invoices", value: 100 },
];
